export default function ({ title, value, valueClass }: { title: any, value: any, valueClass?: string }) {


    return <div className="content-container flex items-center justify-between rounded-md p-2 font-semibold">
        <span>{title}</span>
        <span className={valueClass}>{value}</span>
    </div>
}